import { sword } from '@swordhealth/ui-corporate';
import styled, { css } from 'styled-components';
import { Container } from '@/components/ui/flexbox';

export const Wrapper = styled.div`
  position: ${(props) => (props.$topBanner && !props.$scrolled ? 'sticky' : 'fixed')};
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: ${sword.colors.white};
  box-shadow: rgba(233, 220, 211, 0.4) 0 2px 10px 0;
  transition: all 300ms ease-in-out;
  padding: 12px 0;

  @media (max-width: ${sword.breakpoints.maxSm}) {
    position: relative;
  }

  @media (min-width: ${(props) => props.theme.breakpoints.min_lg}px) {
    ${(props) =>
      !props.$scrolled &&
      css`
        background-color: transparent;
        box-shadow: none;
      `};
  }
`;
export const CustomContainer = styled(Container)`
  max-width: 1400px;
`;

export const WrapperInner = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;

  > div {
    min-height: 48px;
  }

  @media (max-width: ${sword.breakpoints.maxSm}) {
    justify-content: center;
  }

  img {
    align-self: center;
  }

  ${(props) =>
    props.$extraPadding &&
    css`
      @media (min-width: ${sword.breakpoints.minLg}) {
        padding-left: 27px;
        padding-right: 30px;
      }

      @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
        padding-left: 0;
        padding-right: 0;
      }
    `};
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  text-wrap: nowrap;
  opacity: 0;
  transition: all 300ms ease;
  pointer-events: none;

  ${(props) =>
    props.$show &&
    css`
      opacity: 1;
      pointer-events: unset;
    `};

  @media (max-width: ${sword.breakpoints.maxSm}) {
    display: none;
  }
`;
